import { routes } from "config/paths";
import { useWebRouter } from "~utils/next-router/use-web-router";
import { VerticalLayout } from "ui-components";
import { ACCOUNT_USER_ROLE } from "~app-navigation-bar/types/__generated/gql/graphql";
import {
	hasEqualOrHigherAccessThanSpecifiedRole,
	isAccountOwner as isAccountOwnerFn,
	isDatasetCreator as isDatasetCreatorFn,
	isInGroupWithEditAccess as isInGroupWithEditAccessFn,
	isMapCreator as isMapCreatorFn,
	useAuthContext,
	useGetCurrentAccountCache,
	useGetCurrentUserCache,
} from "~auth/index";
import { useGetCurrentDataset } from "~dataset-view/queries/useGetCurrentDataset";
import { useGetCurrentMap } from "~map-view/queries/useGetCurrentMap";

export const AppNavigationBar = ({ children }) => {
	const { route } = useWebRouter();

	const { isAuthenticated, signOut, isTrialExpired, isAccountClosed } =
		useAuthContext();
	const { data: user } = useGetCurrentUserCache();
	const { data: account } = useGetCurrentAccountCache();
	const { data: map } = useGetCurrentMap();
	const { data: dataset } = useGetCurrentDataset();

	return (
		<VerticalLayout
			isTrialExpired={isTrialExpired}
			isAccountClosed={isAccountClosed}
			isAuthenticated={isAuthenticated}
			onSignOut={signOut}
			isAccountOwner={isAccountOwnerFn(account)}
			showMapNavGroup={route.startsWith(
				routes.accountName.maps.mapId.mapName.root,
			)}
			hasMapEditAccess={
				isAccountOwnerFn(account) ||
				(isMapCreatorFn(map, user) &&
					hasEqualOrHigherAccessThanSpecifiedRole(
						account,
						ACCOUNT_USER_ROLE.ADMIN,
					)) ||
				(isInGroupWithEditAccessFn(
					map?.groupsAccesses ?? [],
					user?._userGroupMembers ?? [],
				) &&
					hasEqualOrHigherAccessThanSpecifiedRole(
						account,
						ACCOUNT_USER_ROLE.ADMIN,
					))
			}
			showDatasetNavGroup={route.startsWith(
				routes.accountName.data.datasetId.root,
			)}
			hasDatasetEditAccess={
				isAccountOwnerFn(account) ||
				(isDatasetCreatorFn(dataset, user) &&
					hasEqualOrHigherAccessThanSpecifiedRole(
						account,
						ACCOUNT_USER_ROLE.ADMIN,
					)) ||
				(isInGroupWithEditAccessFn(
					dataset?.groupsAccesses ?? [],
					user?._userGroupMembers ?? [],
				) &&
					hasEqualOrHigherAccessThanSpecifiedRole(
						account,
						ACCOUNT_USER_ROLE.ADMIN,
					))
			}
			// @ts-ignore
			user={user}
			// @ts-ignore
			account={account}>
			{children}
		</VerticalLayout>
	);
};
